'use es6';

let _ = t => t,
  _t;
import styled from 'styled-components';
import pumpkin from 'bender-url!../../../img/pumpkin.svg';
import { TabletAndBelow } from '../themes/mixins';
import { jsx as _jsx } from "react/jsx-runtime";
const LowerRight = styled.div.withConfig({
  displayName: "Pumpkin__LowerRight",
  componentId: "k43hfl-0"
})(["position:absolute;width:auto;right:10px;bottom:0;z-index:100;", ""], TabletAndBelow(_t || (_t = _`
    display: none;
  `)));
export const Pumpkin = () => /*#__PURE__*/_jsx(LowerRight, {
  children: /*#__PURE__*/_jsx("img", {
    src: pumpkin
  })
});